<template>
<!--自定义按钮-->
  <div>
    <div  class="btn-normal" @click="btnClick" :style="[btnStyle]">
      <slot></slot>
    </div>
  </div>


</template>

<script>
export default {
	name: 'my-btn',
	computed: {
    btnStyle(){
      let res = {
        background:"#1890ff",
        color: "white",
        border : "1px solid #1890ff"
      }
      if(this.width){res.width = this.width}
      if (this.type ==='primary2' ){
        res.background = '#ff8a58'
        res.color = "#ffffff"
        res.border = "1px solid #ff8a58"
      } else if (this.type ==='outline' ){
        res.background = 'white'
        res.color = "#1890ff"
        res.border = "1px solid #1890ff"
      }else if (this.type ==='outline2' ){
        res.background = 'white'
        res.color = "#ff8a58"
        res.border = "1px solid #ff8a58"
      }else if (this.type ==='outlineGrey' ){
        res.background = 'white'
        res.color = "#999999"
        res.border = "1px solid #bbbbbb"
      }else if (this.type ==='light' ){
        res.background = '#e9f3ff'
        res.color = "#1890ff"
        res.border = "1px solid #e9f3ff"
      }else if (this.type ==='light2' ){
        res.background = '#ffebe5'
        res.color = "#ff8a58"
        res.border = "1px solid #ffebe5"
      }else if (this.type ==='grey' ){
        res.background = '#f4f4f4'
        res.color = "#111111"
        res.border = "1px solid #f4f4f4"
      }else if (this.type ==='white' ){
        res.background = '#ffffff'
        res.color = "#1890ff"
        res.border = "1px solid #ffffff"
      }else if (this.type ==='white2' ){
        res.background = '#ffffff'
        res.color = "#ff8a58"
        res.border = "1px solid #ffffff"
      }

      if(this.size === 'big'){
        res.fontSize = '16px'
        // res.height = '48px'
        // res.lineHeight = '48px'
        res.padding = '8px 24px'
        res.borderRadius = '8px'
      }else if(this.size === 'default'){
        res.fontSize = '14px'
        // res.height = '40px'
        // res.lineHeight = '40px'
        res.padding = '8px 16px'
        res.borderRadius = '6px'
      }else if(this.size === 'mini'){
        res.fontSize = '12px'
        // res.height = '32px'
        // res.lineHeight = '32px'
        res.padding = '6px 8px'
        res.borderRadius = '4px'
      }

      if(this.isRadius){
        res.borderRadius = '100px'
      }
      return res

    }

  },
	props: {
		type: {
			type:String,
			default:"primary", // 按钮类型  primary 主按钮,   outline 描边 ,light浅蓝色, grey 灰底黑色 ； white 白底蓝色 ；white2 白底橙色
		},

		size:{
			type:String,
			default:"default",  // 按钮大小： big 16-高48； default 14-40； mini 12-36；
		},

		width:{
			type:String,
			default:'',  // 宽度： px 或者百分比
		},

    isRadius:{
      type:Boolean,
      default:false  //是否是 满圆角
    }

	},
	data() {
		return {
		};
	},
	methods: {
		btnClick(){
			this.$emit('click')
		},
	},
}
</script>


<style  scoped >
.btn-normal{
  display: inline-block;
  text-align: center;
  box-sizing: border-box;

  font-weight: 600;
  line-height: 24px;
}


</style>
